'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { ComboboxOptionContext } from './context/combobox-option.context';
import { comboboxOptionMetaRecipe } from './styles/combobox-option-meta.styles';
import type { ComboboxOptionMetaPropsInterface } from './types/combobox-option-meta.types';

/**
 * @since 10.0.0
 */
export const ComboboxOptionMeta = forwardRef<HTMLSpanElement, ComboboxOptionMetaPropsInterface>(
  (props: ComboboxOptionMetaPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;
    const { disabled, selected } = useContext(ComboboxOptionContext);
    const styles = css(comboboxOptionMetaRecipe.raw({ disabled, selected }), cssProp);
    return (
      <span
        ref={forwardedRef}
        data-c11n-component="Combobox.OptionMeta"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

ComboboxOptionMeta.displayName = 'Combobox.OptionMeta';
